import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=3209a935&"
import script from "./Instruction.vue?vue&type=script&lang=ts&"
export * from "./Instruction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports